<template>
    <div role="presentation" class="marginToolbar">
        <!-- <div class="container-box-ck">
            <div class="box-cookie">
                <v-card class="bg-card contrasteExtra">
                    <v-card-text style="min-width: 250px">
                        <div v-show="!showOpcao">
                            <div>
                                <strong class="font-size-2 cl-color-dark">Controle sua privacidade</strong>
                            </div>
                            <span class="mt-4">
                                <router-link class="font-size-1" :to="{name: 'documentosMenu', params: {doc: 'politicaPrivacidade'}}">Política de Privacidade</router-link> -
                                <router-link class="font-size-1" :to="{name: 'documentosMenu', params: {doc: 'termoUso'}}">Termos de Uso</router-link>
                            </span>
                            <div class="mt-2 content-between">
                                <v-btn outline small color="info" @click="showOpcao = true">Opções</v-btn>
                                <v-btn outline small color="success">Aceito</v-btn>
                            </div>
                        </div>
                        <div v-show="showOpcao">
                            <div class="content-between">
                                <strong class="font-size-2 cl-color-dark">Suas opções</strong>
                                <v-btn small icon style="margin-top: -5px" @click="showOpcao = false"><i class="fas fa-times"></i></v-btn>
                            </div>
                            <div class="content-between mr-3">
                                <strong class="font-size-2 pointer" @click="showNecessario = !showNecessario">Necessários (1)</strong>
                                <div class="pull-right">
                                    <v-switch style="margin-top: -8px" input-value="true" disabled></v-switch>
                                </div>
                            </div>
                            <div v-show="showNecessario" class="px-3">
                                <div class="content-between">
                                    <strong class="font-size-2">ASP.NET_SessionId</strong>
                                    <div class="pull-right pl-3">
                                        <v-switch input-value="true" disabled style="margin-top: -8px"></v-switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </div> -->
        <div class="elemento-pai" :style="[telaGrande ? {'margin-left': '20% !important'} : '']">
            <div class="elemento-filho " :style="[telaGrande ? {'max-width': '40% !important'} : {'max-width': '95% !important'}]">             
                <div class="contrasteExtra ">
                    <div-text class="mt-2 "  style="min-height: 400px; overflow-y: hidden">
                        <div  v-if="showCpfCnpj" > 
                            <h3 class="text-left mt-2 acessibilidade">Olá! <br/>
                              Negocie suas dívidas de forma rápida, simples e segura.</h3>
                              <h4>Para consultar seus débitos é muito fácil! Basta colocar seu CPF ou CNPJ.</h4>
                               
                                    <form style="margin-top: 20px; height: 100px;">  
                                        <label for="inputCpfCnpj" class="colorLabel acessibilidade">Consulte seu CPF/CNPJ</label>
                                        <div class="input-group input-group-lg" >
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <i class="fas fa-user"></i>
                                                </div>
                                            </div>
                                            <input
                                            id="inputCpfCnpj"
                                            @input="validarCampo(errorMessages.cpfCnpj, form.cpfCnpj)"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']" 
                                            v-model="form.cpfCnpj"  
                                            type="text" 
                                            v-bind:class="{'is-invalid' : errorMessages.cpfCnpj.message !== ''}"
                                            style="background-image: none !important"
                                            class="form-control" 
                                            placeholder="999.999.999-99" 
                                            aria-label="Digite seu CPF/CNPJ"
                                            aria-autocomplete="inline"
                                            aria-activedescendant="result"
                                            autocomplete="on"
                                            :disabled="showTemAcesso || showFirstStep1"
                                            >
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="errorMessages.cpfCnpj.message!== '' " >{{errorMessages.cpfCnpj.message}}</small>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" v-model="concordaComTermosCheck">
                                            <label class="form-check-label font-size-1" :class="{'cl-color-red': alertaConcordaComTermosCheck}" for="flexCheckChecked">
                                                Ao pesquisar seu CPF você concorda com a 
                                                <router-link  :class="{'cl-color-red': alertaConcordaComTermosCheck}" :to="{name: 'documentosMenu', params: {doc: 'politicaPrivacidade'}}">Política de Privacidade</router-link>
                                                <span v-if="alertaConcordaComTermosCheck"> (Obrigatório)</span>
                                            </label>
                                        </div>
                                    </form>
                              
                                <center-element v-if="showEntrar"  aria-label="Verificação reCaptcha." style="max-width: 100% !important">
                                    <div role="presentation" id="reCaptcha">
                                        <form action="?" method="POST" id="recp">
                                            <div style="transform:scale(0.85);-webkit-transform:scale(0.85);" id="recaptcha-container" 
                                            data-callback="onLoadReCaptcha" data-expired-callback="expireReCaptcha"></div>
                                            <br/>
                                        </form>
                                    </div>
                                </center-element>
                            <v-btn id="btnBuscar" ref="btnBuscar" style="clear: both" aria-label="Buscar cpf/cnpj" v-if="showEntrar" class="pa-0 right" color="info"  :disabled="!loadRecaptcha" @click="buscarCpfCnpj()" @keyup.enter="buscarCpfCnpj()">Buscar</v-btn>                            
                        </div>
                        <!-- Primeiro acesso -->                        
                        <div>
                            <!-- 1° etapa: Solicitar código -->
                            <div v-if="showFirstStep1" id="reset-senha" class="mt-4">
                                <h6 class="text-left colorLabel acessibilidade">Informe seu e-mail e celular para receber o código de ativação</h6>
                                <!-- <div class="elemento-pai mt-3">
                                    <div class="elemento-filho">  -->
                                    <div class="mt-3">
                                        <form>
                                            <label for="email" class=" colorLabel acessibilidade">E-mail</label>
                                            <div class="form-group">
                                                <div class="input-group input-group-lg">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" >@</span>
                                                    </div>
                                                    <input 
                                                    id="email"
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="nome@exemplo.com.br" 
                                                    aria-label="E-mail."
                                                    @input="validandoEmail()"
                                                    v-model="form.email" 
                                                    v-bind:class="{'is-invalid' : errorMessages.email.message !== ''}"
                                                    style="background-image: none !important"
                                                    >
                                                </div>
                                                <div role="alert">
                                                    <small class="form-text text-danger" v-show="errorMessages.email.message!== '' " >{{errorMessages.email.message}}</small>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="celular" class=" colorLabel acessibilidade">Celular</label>
                                                <div class="input-group input-group-lg">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" ><i class="fas fa-mobile"></i></span>
                                                    </div>
                                                    <input 
                                                    id="celular"
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="(99) 99999-9999" 
                                                    aria-label="Digite seu ddd e celular"
                                                    v-model="form.telefone" 
                                                    v-bind:class="{'is-invalid' : errorMessages.telefone.message !== ''}"
                                                    style="background-image: none !important"
                                                    v-mask="'(##) #####-####'"                                                              
                                                    >
                                                    <!-- @input="validarCampo(errorMessages.telefone, form.telefone)" -->
                                                </div>
                                                <div role="alert">
                                                    <small class="form-text text-danger" v-show="errorMessages.telefone.message !== '' " >{{errorMessages.telefone.message}}</small>
                                                </div>
                                            </div> 
                                        </form>                                        
                                        <v-btn  aria-label="Voltar para login" class="left mb-5" color="warning" @click="showBuscaCpfCnpj()">Voltar</v-btn>
                                        <v-btn  aria-label="Solicitar código" class="right mb-5" color="info"  @click="solicitarCodigo()">OK</v-btn>
                                    </div>
                                    <!-- </div>
                                </div> -->
                            </div>
                            <!-- 2° etapa: Conferir código -->
                            <div class="" v-if="showFirstStep2" >
                                <h2 class="text-left acessibilidade">Código de acesso</h2>
                                <div v-if="showCampoCodigo">
                                    <h3 class="text-left acessibilidade">Que bom ter você por aqui!</h3> 
                                    <h4 class="text-left acessibilidade"> Te enviamos por e-mail ou SMS um código de acesso. Por favor, inserir abaixo para acessar.</h4>
                                    <h5 class="text-left acessibilidade mt-3">CPF/CNPJ: {{form.cpfCnpj}}</h5>
                                </div>
                                <div class="mt-2">
                                    <div class="" style="min-height: 100px; margin-bottom: 70px" v-if="showCampoCodigo">
                                        <form>
                                            <label for="senhaValidacao" class="colorLabel acessibilidade">Código</label>
                                            <div class="input-group input-group-lg" >
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">
                                                    <i class="fas fa-lock"></i>
                                                    </div>
                                                </div>
                                                <input
                                                id="senhaValidacao"
                                                @input="validarCampo(errorMessages.senhaRecebida, form.senhaRecebida)"
                                                v-model="form.senhaRecebida"  
                                                type="password" 
                                                v-bind:class="{'is-invalid' : errorMessages.senhaRecebida.message !== ''}"
                                                style="background-image: none !important"
                                                class="form-control" 
                                                placeholder="Digite aqui o código" 
                                                aria-label="Senha de acesso"
                                                @keyup.enter="login(form.senhaRecebida, 'conferir')"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-if="errorMessages.senhaRecebida.message!== '' " >{{errorMessages.senhaRecebida.message}}</small>
                                            </div>
                                        </form>
                                        <div class="col-sm-12 " style="height: 20px">
                                            <a href="#" class="right" style="color:#42A5F5" @click="showBuscaCpfCnpj()">Entrar com outro usuário</a>
                                        </div>
                                        <div class="col-sm-12 " style="">
                                            <div class="col-sm-12  pr-0 pl-0">
                                                <v-btn aria-label="Reenviar código" class="left px-1" :style="[!telaGrande ? {'font-size': '12px'} : '']" color="info"  @click="showEmailCelular()">Reenviar <br v-if="!telaGrande">código</v-btn>
                                                <v-btn aria-label="Conferir senha" class="right px-0" color="success"  @click="login(form.senhaRecebida, 'conferir')">Conferir</v-btn>
                                            </div>
                                        </div>
                                    </div>                                
                                    <div v-if="showTrocaSenha" >
                                        <h3 class="text-left acessibilidade">Criando seu cadastro</h3>
                                        <h4 class="text-left acessibilidade mt-3">Por favor, cadastre uma senha para facilitar seus próximos acessos</h4>
                                        <form class="mt-4">  
                                            <label for="senhaNova" class="colorLabel acessibilidade">Nova Senha</label>
                                            <div class="form-group">
                                                <div class="input-group input-group-lg" >
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                        <i class="fas fa-lock"></i>
                                                        </div>
                                                    </div>
                                                    <input
                                                    id="senhaNova"
                                                    @input="validarCampo(errorMessages.novaSenha, form.novaSenha)"
                                                    v-model="form.novaSenha"  
                                                    type="password" 
                                                    v-bind:class="{'is-invalid' : errorMessages.novaSenha.message !== ''}"
                                                    style="background-image: none !important"
                                                    class="form-control" 
                                                    placeholder="Digite aqui a nova senha" 
                                                    aria-label="Nova senha."
                                                    >
                                                </div>
                                                <div role="alert">
                                                    <small class="form-text text-danger" v-show="errorMessages.novaSenha.message!== '' " >{{errorMessages.novaSenha.message}}</small>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="senhaConfirm" class="colorLabel acessibilidade">Confirme a senha</label>
                                                <div class="input-group input-group-lg" >
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                        <i class="fas fa-lock"></i>
                                                        </div>
                                                    </div>
                                                    <input
                                                    id="senhaConfirm"
                                                    @input="validarCampo(errorMessages.confirmaSenha, form.confirmaSenha)"
                                                    v-model="form.confirmaSenha"  
                                                    type="password" 
                                                    v-bind:class="{'is-invalid' : errorMessages.confirmaSenha.message !== ''}"
                                                    style="background-image: none !important"
                                                    class="form-control" 
                                                    placeholder="Confirme aqui a nova senha" 
                                                    aria-label="Confirme a senha."
                                                    required
                                                    >
                                                </div>
                                                <div role="alert">
                                                    <small class="form-text text-danger" v-show="errorMessages.confirmaSenha.message!== '' " >{{errorMessages.confirmaSenha.message}}</small>
                                                </div>
                                            </div>
                                        </form>
                                        <v-btn class="right" color="success" @click="mudarSenha()">Entrar</v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Possui acesso -->
                        <div id="acesso"  v-if="showTemAcesso" >
                            
                                <form v-on:submit.prevent="login(form.senha, 'entrarLogin')"> 
                                    <label for="senhaAcesso" class="colorLabel acessibilidade">Senha</label>
                                    <div class="input-group input-group-lg" >
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <i class="fas fa-lock"></i>
                                            </div>
                                        </div>
                                        <input
                                        tabindex="0"
                                        id="senhaAcesso"
                                        name="senhaAcesso"
                                        @input="validarCampo(errorMessages.senha, form.senha)"
                                        v-model="form.senha"  
                                        type="password" 
                                        v-bind:class="{'is-invalid' : errorMessages.senha.message !== ''}"
                                        style="background-image: none !important; "
                                        class="form-control" 
                                        placeholder="Digite aqui sua senha" 
                                        aria-label="Senha"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="errorMessages.senha.message!== '' " >{{errorMessages.senha.message}}</small>
                                    </div>
                                </form>
                                <div style="">
                                    <a href="#reset-senha" class="right colorTag" tabindex="0"  @click="showEmailCelular()" >Esqueci minha senha</a>
                                    <v-btn class="pa-0 right" color="success" style="clear: right" @click="login(form.senha, 'entrarLogin')">Entrar</v-btn>                            
                                </div>
                     
                        </div>
                    </div-text>
                </div>
                <v-tour name="myTour" :steps="steps" :options="options" tabindex="0" :callbacks="myCallbacks"></v-tour>
            </div>
        </div>
        <Carregando aria-live="assertive"></Carregando>
    </div>
</template>

<script>

require('@/service/service_autoatendimento/httpsemtoken')
require('@/service/service_pagamento/httpsemtoken')
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
import { postLogin } from '@/service/service_autoatendimento/token'
import { postSolicitaCodigo, getValidaCpfCnpj, getAceite } from '@/service/service_autoatendimento/autoatendimentosemtoken'
import { patchSenha } from '@/service/service_autoatendimento/autoatendimento'
import Carregando from '../MyComponents/Carregando.vue'
import CenterElement from '../MyComponents/CenterElement.vue'
export default {
    components: {Carregando, CenterElement},
    data: function (){
        return {            
            options: {
                useKeyboardNavigation: true,
                labels:{
                    buttonSkip: 'Pular tutorial',
                    buttonPrevious: 'Anterior',
                    buttonNext: 'Próximo',
                    buttonStop: 'Fim'

                }
            },
            myCallbacks: {
                onStop: this.stopTourCallback,
            },
            steps: [
                {
                    target: '#inputCpfCnpj',
                    content: 'Digite seu CPF ou CNPJ'
                },
                {
                    target: '#reCaptcha',
                    content: 'Valide o reCaptcha'
                },
                {
                    target: '#btnBuscar',
                    content: 'Busca o CPF ou CNPJ'
                }
            ],
            activeBtn: 1,
            showNav: false,
            drawer: false,
            concordaComTermosCheck: true,
            alertaConcordaComTermosCheck: false,
            form: {
                cpfCnpj: '',
                senha: '',
                email: '',
                telefone: '',
                senhaRecebida: '',
                novaSenha: '',
                confirmaSenha: '',
                codigo: ''
            },
            loadRecaptcha: false,
            showCpfCnpj: true,
            showFirstStep1: false,
            showFirstStep2: false,
            showTemAcesso: false,
            showEntrar: true,
            showTrocaSenha: false,
            showSenha: false,
            showSenhaRecebida: false,
            showNovaSenha: false,
            showConfirmaSenha: false,
            showCampoCodigo: false,
            errorMessages: {
                cpfCnpj: {
                    message: ''
                },
                email: {
                    message: ''
                },
                telefone: {
                    message: ''
                },
                senha: {
                    message: ''
                },
                senhaRecebida: {
                    message: ''
                },
                novaSenha: {
                    message: ''
                },
                confirmaSenha: {
                    message: ''
                }
            },
            primeiroAcesso: false,
            
        }
    },
    computed: {
        telaGrande(){
            return Vuex.state.large
        },
        showTutorial() {
            return sessionStorage.getItem('TUTORIAL') == null
        }
    },
    created(){
        Vuex.commit('SET_USER', {nome: '', cpfCnpjFormat: '', cpfCnpj: ''})
        Vuex.commit('SET_LOGIN', true)
        // para reCaptcha conseguir ver a função
        window.onLoadReCaptcha = this.onLoadReCaptcha
        window.expireReCaptcha = this.expireReCaptcha
        sessionStorage.setItem('TOKEN', '')
        sessionStorage.setItem('LOGIN', '')
        sessionStorage.setItem('TOKEN_CRIADO', '')
        sessionStorage.setItem('TOKEN_EXPIRA', '')
        sessionStorage.setItem('user_name', '')
        sessionStorage.setItem('user_codigo', '')
        // sessionStorage.setItem('TOKEN_TABELA', '')
        // sessionStorage.setItem('LOGIN_TABELA', '')
        // sessionStorage.setItem('TOKEN_CRIADO_TABELA', '')
        // sessionStorage.setItem('TOKEN_EXPIRA_TABELA', '')
    },
    mounted(){
        Vuex.commit('SET_ACORDOS', [])
        Vuex.commit('SET_DIVIDAS', [])
        
        window.fonte('login')
        if(this.showTutorial) {
            this.$tours['myTour'].start()
            window.addEventListener('keyup', this.$tours['myTour'].handleKeyup)
        }
        // para não dar bug no carregamento do reCaptcha
        if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true)
        window.onresize = ()=>{
            if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
            else Vuex.commit('SET_TELA', false)  
        }
        setTimeout(() => {
            window.grecaptcha.ready(function() {
                window.grecaptcha.render("recaptcha-container", {
                    "sitekey": "6LdYZ9EUAAAAAPwZPCPuqypqipJW6Y9rB_z-Kuq3"
                });
            });
        }, 300)
        document.getElementById('inputCpfCnpj').focus()
    },
    
    methods: {
        stopTourCallback() {
            sessionStorage.setItem('TUTORIAL', false)

        },
        validarCampo(message, campo){
            bus.$emit('close-alert')
            if(campo.length === 0){
                message.message = 'Campo obrigatório'
            } else {
                message.message = ''
            }
        },
        validandoEmail(){
            // if(this.form.email.length === 0) this.errorMessages.email.message = 'Campo obrigatório'
            // else 
            if(!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi.test(this.form.email))  this.errorMessages.email.message = 'Inválido'            
            else this.errorMessages.email.message = ''
        },
        onLoadReCaptcha(){
            this.loadRecaptcha = true
            setTimeout(() => {
              let btn =  document.getElementById('btnBuscar')
              btn.focus()
            }, 500)
            
        },
        expireReCaptcha(){
            this.loadRecaptcha = false
        },
        buscarCpfCnpj(){
            try {
                if(!this.loadRecaptcha) return
                this.$tours['myTour'].stop()
                var cpfCnpj = this.form.cpfCnpj.replace(/[^0-9]/g, '')
                if(this.form.cpfCnpj === ''){
                    this.errorMessages.cpfCnpj.message = 'Campo obrigatório'
                    return
                } else if(cpfCnpj.length !== 14 && cpfCnpj.length !== 11) {
                    this.errorMessages.cpfCnpj.message = 'Inválido'
                    return
                } else if (!this.concordaComTermosCheck) {
                    this.alertaConcordaComTermosCheck = true
                    return
                }
                bus.$emit('load-in', {text: 'Carregando'})
                this.alertaConcordaComTermosCheck = false
                getValidaCpfCnpj(Number(this.form.cpfCnpj.replace(/[^0-9]/g, ''))).then(response =>{
                    bus.$emit('load-out')
                    Vuex.commit('SET_CARD_COOKIE', false)
                    if(response.data.Retorno === 3) this.showEntrarAcesso()
                    else if(response.data.Retorno === 2 || response.data.Retorno === 4) this.showEmailCelular()
                    // else if(response.data.Retorno === 4) this.showRedefinirSenha()
                }).catch((error)=>{
                    bus.$emit('load-out')
                    var errorMessage = ''
                    this.form.cpfCnpj = ''
                    if(error.response.status === 404) errorMessage = 'Não localizamos nenhum contrato para negociarmos referente ao seu CPF/CNPJ.'
                    if(error.response.status === 404) errorMessage = 'Não localizamos nenhum contrato para negociarmos referente ao seu CPF/CNPJ.'
                    else if (error.response.status === 500) errorMessage = 'Erro ao validar CPF/CNPJ.'
                    else errorMessage = error.response ? error.response.data.Message : 'Erro nao identificado'
                    this.$swal.fire({
                        type: 'error',
                        // title: 'Erro inesperado!',
                        text: errorMessage
                    })
                    // bus.$emit('alert-danger', errorMessage)
                })
            } catch(error){
                // console.log(error)
            }

        },
        showBuscaCpfCnpj(){
            this.loadRecaptcha = false    
            this.form.cpfCnpj = ''
            this.showCpfCnpj = true
            this.showEntrar = true
            this.errorMessages.cpfCnpj.message = ''
            this.showFirstStep1 = false
            this.showFirstStep2 = false
            window.grecaptcha.ready(function() {
                window.grecaptcha.render("recaptcha-container", {
                    "sitekey": "6LdYZ9EUAAAAAPwZPCPuqypqipJW6Y9rB_z-Kuq3"
                });
            });
            setTimeout(() => {
                document.getElementById('inputCpfCnpj').focus()
            }, 500)
        },
        showEmailCelular(){
            this.showEntrar = false
            this.loadRecaptcha = false
            this.errorMessages.email.message = ''
            this.errorMessages.telefone.message = ''
            this.showFirstStep2 = false
            this.showTemAcesso = false
            this.showFirstStep1 = true
            
            setTimeout(() => {
                document.getElementById('email').focus()
            }, 500)
        },
        // Form código verificação
        showRedefinirSenha() {
            this.form.novaSenha = ''
            this.form.confirmaSenha = ''
            this.errorMessages.senhaRecebida.message = ''
            this.errorMessages.novaSenha.message = ''
            this.errorMessages.confirmaSenha.message = ''            
            this.showFirstStep1 = false
            this.showCpfCnpj = false
            this.showTemAcesso = false
            this.showFirstStep2 = true
            this.showCampoCodigo = true
            this.showTrocaSenha = false
            setTimeout(() => {
                document.getElementById('senhaValidacao').focus()
            }, 500)
        },
        showEntrarAcesso(){
            this.showTemAcesso = true
            this.primeiroAcesso = false
            this.form.senha = ''
            this.errorMessages.senha.message = ''
            this.showEntrar = false
            this.loadRecaptcha = false
            this.showFirstStep1 = false
            this.showFirstStep2 = false
            this.showTrocaSenha = false
            this.showCpfCnpj = true
            setTimeout(() => {
                document.getElementById('senhaAcesso').focus()
            }, 500)
        },
        async solicitarCodigo(){
            try {                
                var txtTel = this.form.telefone.replace(/[^0-9]/g, '')
                if(!this.form.cpfCnpj.trim()){
                    this.errorMessages.cpfCnpj.message = 'Campo obrigatório'
                    return
                }
                if(!this.form.email.trim() && !this.form.telefone.trim()){
                    this.errorMessages.email.message = 'Campo obrigatório'
                    return
                } else if(this.errorMessages.email.message !== '') return
                // if(!this.form.telefone.trim()){
                //     this.errorMessages.telefone.message = 'Campo obrigatório'
                //     return  
                // }
                // else 
                if(this.form.telefone.trim() && txtTel.length !== 11) {
                    this.errorMessages.telefone.message = 'Número inválido'
                    return
                }
                bus.$emit('load-in', {text: 'Carregando'})

                var obj = {
                    nrInscricao: Number(this.form.cpfCnpj.replace(/[^0-9]/g, '')),
                    email: this.form.email,
                    telefone: {
                        nrDDD: Number(txtTel.slice(0,2)),
                        nrTelefone: Number(txtTel.slice(2))
                    }
                }
                var response = await postSolicitaCodigo(obj)
                bus.$emit('load-out')
                if(response === undefined){
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text:'Não encontramos débitos para esta inscrição.'
                    })                    
                } else this.showRedefinirSenha()
            } catch(error){
                bus.$emit('load-out')
                if (error.response.status) {
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.Message
                    })
                } else {
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text:'Erro ao solicitar código.'
                    })
                }
                // error.response.data.Message
            }
        },
        login(senha, origem){
            try {
                var obj = {
                    UserName: this.form.cpfCnpj.replace(/[^0-9]/g, ''), //tira os caracteres
                    password: senha,
                    grant_type: 'password'
                }
                if(!this.form.cpfCnpj){
                    this.errorMessages.cpfCnpj.message = 'Campo obrigatório'
                    return
                } else if(obj.UserName.length !== 14 && obj.UserName.length !== 11) {
                    this.errorMessages.cpfCnpj.message = 'Inválido'
                    return
                }
                if(!obj.password){
                    this.errorMessages.senha.message = 'Campo obrigatório'
                    this.errorMessages.senhaRecebida.message = 'Campo obrigatório'
                    return
                }
                bus.$emit('load-in', {text: 'Carregando'})
                postLogin(obj).then(response => {
                    var txtTemp = JSON.stringify(response)
                    response = JSON.parse(txtTemp)
                    var token = 'Bearer ' + response.data.access_token
                    var data = new Date()
                    sessionStorage.setItem('TOKEN', token)
                    sessionStorage.setItem('LOGIN', data.valueOf())
                    sessionStorage.setItem('TOKEN_CRIADO', response.data['.issued'])
                    sessionStorage.setItem('TOKEN_EXPIRA', response.data['.expires'])
                    sessionStorage.setItem('user_name', response.data.Nome)
                    sessionStorage.setItem('user_codigo', obj.UserName)
                    Vuex.commit('SET_USER', {nome: response.data.Nome, cdPessoa: response.data.Codigo, cpfCnpjFormat: this.form.cpfCnpj, cpfCnpj: obj.UserName})

                    bus.$emit('load-out')
                    if(response.data.primeiroAcesso === 'True'){
                        this.form.senhaRecebida = obj.password
                        this.form.codigo = obj.password
                        if(origem === 'entrarLogin'){
                            this.showRedefinirSenha()
                        }
                        this.showTrocaSenha = true
                        this.showCampoCodigo = false     
                    } 
                    else {
                        this.validaAceite()
                        this.$router.push({name:'inicio'})
                    }
                }).catch((error)=>{
                    bus.$emit('load-out')
                    this.$swal.fire({
                        type: 'error',
                        // title: 'Erro inesperado!',
                        text: error.response.data.error_description
                    })
                    // bus.$emit('alert-danger', error.response.data.error_description)
                })
                // postToken(obj).then(response => {
                //     var txtTemp = JSON.stringify(response)
                //     response = JSON.parse(txtTemp)
                //     var token = 'Bearer ' + response.data.access_token
                //     var data = new Date()
                //     sessionStorage.setItem('TOKEN_TABELA', token)
                //     sessionStorage.setItem('LOGIN_TABELA', data.valueOf())
                //     sessionStorage.setItem('TOKEN_CRIADO_TABELA', response.data['.issued'])
                //     sessionStorage.setItem('TOKEN_EXPIRA_TABELA', response.data['.expires'])
                //     bus.$emit('load-out')
                // }).catch((error)=>{
                //     bus.$emit('load-out')
                //     bus.$emit('alert-danger', error.response.data.error_description)
                // })
            } catch(error){
                // console.log(error.response)
            }
        },
        async validaAceite() {
            try {
                let res = await getAceite(Vuex.state.user.cdPessoa)
                if (res.data.dtAceite) Vuex.commit('SET_CARD_COOKIE', false)
                else Vuex.commit('SET_CARD_COOKIE', true)
            } catch (e) {
                // console.log('Erro ao validar aceite', e)
            }
        },
        async mudarSenha(){
            try {
                if(this.form.novaSenha === ''){
                    this.errorMessages.novaSenha.message = 'Campo obrigatório'
                    return
                }
                if(this.form.confirmaSenha === ''){
                    this.errorMessages.confirmaSenha.message = 'Campo obrigatório'
                    return
                }
                if(this.form.novaSenha !== this.form.confirmaSenha){
                    this.errorMessages.confirmaSenha.message = 'Senha diferente'
                    return
                }                
                var obj = {
                    senhaAtual: this.form.codigo,
                    senhaNova: this.form.novaSenha
                }
                await patchSenha(obj)
                this.login(obj.senhaNova, 'entrarMudaSenha')
            } catch(error){
                this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text:'Erro ao mudar a senha.'
                })
            }
        }
     }
}
</script>
<style>

</style>
